/** Match PublicWWW site table: spaced thousands (e.g. 11 766 677) or ">30M" from CSV bucket. */
export function formatPublicWwwRank(rank) {
  if (rank == null) return '—';
  const n = Number(rank);
  if (n === 31_000_000) return '>30M';
  if (!Number.isFinite(n)) return '—';
  return String(Math.trunc(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

/** Lowest website rank first; >30M sentinel and null ranks last. */
export function sortPublicWwwByRankAsc(rows) {
  if (!rows?.length) return [];
  return [...rows].sort((a, b) => {
    const ra = a?.rank ?? a?.publicWwwRank;
    const rb = b?.rank ?? b?.publicWwwRank;
    const na = ra == null ? Number.MAX_SAFE_INTEGER : Number(ra);
    const nb = rb == null ? Number.MAX_SAFE_INTEGER : Number(rb);
    if (na !== nb) return na - nb;
    const ua = String(a?.url ?? a?.informationValue ?? '');
    const ub = String(b?.url ?? b?.informationValue ?? '');
    return ua.localeCompare(ub, undefined, { sensitivity: 'base' });
  });
}
